module.exports = __webpack_public_path__ + "img/qr_code.50620b6b.jpg";